  import React, { useEffect } from "react";
  import axios from "axios";

  export default function IncumbenciasFetcher({ schoolName, onFetch }) {
    useEffect(() => {
      if (!schoolName) {
        onFetch([]); // limpiar si no hay nombre
        return;
      }

      const trimmedName = schoolName.trim();

      // Validación mínima: al menos 4 caracteres o "todas"
      if (trimmedName.length < 5 && trimmedName.toLowerCase() !== "todas") {
        onFetch([]); // no hacemos la consulta
        return;
      }

      const controller = new AbortController(); // para evitar fugas si desmonta

      const fetchData = async () => {
        try {
          const response = await axios.post(
            `https://wwwa.isepsantafe.net.ar/expedientes/docentes/getIncumbenciasPorReferencia/${encodeURIComponent(
              trimmedName
            )}`,
            {},
            { signal: controller.signal }
          );
          onFetch(response.data.incumbencias || []);
        } catch (error) {
          if (axios.isCancel(error)) return;
          console.error("Error al obtener incumbencias:", error);
          onFetch([]);
        }
      };

      fetchData();

      return () => controller.abort();
    }, [schoolName, onFetch]);

    return null;
  }
